import { useGroupChildByParentId } from '@/Pages/Run/utils/useGroupChildByParentId';
import { useRunsInTreeStructure } from '@/Pages/Run/utils/useRunsInTreeStructure';

import { useRunsQuery } from './useSwr';

export function useGetFlattenedChildRunsForRuns(params: {
  runIds?: string[];
  sessionId?: string;
}) {
  const { runIds, sessionId } = params;
  const rootRuns = useRunsQuery(
    runIds !== undefined
      ? {
          id: runIds,
          select: ['child_run_ids', 'inputs', 'outputs', 'start_time'],
          session: sessionId ? [sessionId] : [],
        }
      : null
  );

  const sortedRootRuns = rootRuns.data?.runs.sort((a, b) => {
    const aIndex = runIds?.indexOf(a.id) ?? -1;
    const bIndex = runIds?.indexOf(b.id) ?? -1;
    return aIndex - bIndex;
  });

  const childRunIds =
    sortedRootRuns?.map((rootRun) => rootRun.child_run_ids ?? []).flat() ?? [];

  const childRuns = useRunsQuery(
    runIds !== undefined && childRunIds.length > 0
      ? {
          id: childRunIds,
          session: sessionId ? [sessionId] : [],
          start_time: sortedRootRuns?.[0].start_time,
        }
      : null
  );

  const childRunLookup = useGroupChildByParentId(
    childRuns.data?.runs,
    childRuns.isLoading
  );

  const { tree } = useRunsInTreeStructure({
    rootRuns: sortedRootRuns ?? [],
    childRunLookup: childRunLookup ?? {},
    filteredRuns: childRuns.data?.runs,
    filteredOnly: false,
    userAllRuns: true,
    foldedRuns: [],
  });

  return {
    isLoading: rootRuns.isLoading || childRuns.isLoading,
    error: rootRuns.error || childRuns.error,
    flatRuns: tree.flattenedRuns,
  };
}
